/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'

import React from 'react'

interface PropsType {
	className?: string
	style?: React.CSSProperties
	children?: React.ReactNode
}

export const View = styled.div(
	{
		boxSizing: 'border-box',
	},
	(props: PropsType) => {
		return { ...props.style }
	},
)
